import React, { useState } from 'react';
import { FaTrashAlt, FaEdit, FaSave, FaTimes } from 'react-icons/fa';

export default function TablaCostosSL({ productos, calcularEstructuraCosto, calcularPVP, editarProducto, eliminarProducto }) {
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({ materiales: '', horas: '' });

    const formatCurrency = (value) => Number(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

    const handleEditClick = (item) => {
        setEditingId(item.id);
        setEditForm({ materiales: item.materiales, horas: item.horas });
    };

    const handleSave = async (id) => {
        await editarProducto(id, editForm);
        setEditingId(null);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-600">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200">
                    <tr>
                        <th className="px-4 py-3 font-bold">Producto</th>
                        <th className="px-4 py-3 text-center font-bold">Dpto</th>
                        <th className="px-4 py-3 text-right font-bold">Coste Mat.</th>
                        <th className="px-4 py-3 text-right font-bold">Mano Obra (+SS)</th>
                        <th className="px-4 py-3 text-right font-bold">Gastos Fijos</th>
                        <th className="px-4 py-3 text-right font-bold">Coste Total SL</th>
                        <th className="px-4 py-3 text-right font-bold bg-gray-100 text-teal-900">PVP (Sin IVA)</th>
                        <th className="px-4 py-3 text-right font-bold bg-teal-50 text-teal-900">PVP (CON IVA 21%)</th>
                        <th className="px-4 py-3 text-center font-bold">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {productos.map((item) => {
                        const isEditing = editingId === item.id;
                        const { costoManoObraTotal, absorcionGastosFijos, costoTotalEmpresa } = calcularEstructuraCosto(
                            isEditing ? editForm.materiales : item.materiales, 
                            isEditing ? editForm.horas : item.horas, 
                            item.gastoFijoHora
                        );
                        const { pvpSinIva, pvpConIva } = calcularPVP(costoTotalEmpresa);

                        return (
                            <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50">
                                <td className="px-4 py-3 font-medium text-gray-900 max-w-xs truncate">{item.producto}</td>
                                <td className="px-4 py-3 text-center">
                                    <span className={`px-2 py-0.5 rounded text-xs font-bold ${item.departamento === 'T' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
                                        {item.departamento || 'C'}
                                    </span>
                                </td>
                                
                                {/* Celdas Editables */}
                                <td className="px-4 py-3 text-right font-mono">
                                    {isEditing ? (
                                        <input type="number" step="0.01" className="w-20 p-1 border border-blue-500 rounded text-right" value={editForm.materiales} onChange={(e) => setEditForm({...editForm, materiales: e.target.value})} />
                                    ) : formatCurrency(item.materiales)}
                                </td>
                                <td className="px-4 py-3 text-right font-mono text-gray-500">
                                    {isEditing ? (
                                        <input type="number" step="0.5" className="w-16 p-1 border border-blue-500 rounded text-right" value={editForm.horas} onChange={(e) => setEditForm({...editForm, horas: e.target.value})} />
                                    ) : `${formatCurrency(costoManoObraTotal)} (${item.horas}h)`}
                                </td>

                                <td className="px-4 py-3 text-right font-mono text-gray-500">{formatCurrency(absorcionGastosFijos)}</td>
                                <td className="px-4 py-3 text-right font-mono font-semibold text-gray-900">{formatCurrency(costoTotalEmpresa)}</td>
                                <td className="px-4 py-3 text-right font-mono font-semibold bg-gray-50 text-gray-800">{formatCurrency(pvpSinIva)}</td>
                                <td className="px-4 py-3 text-right font-mono font-bold bg-teal-50 text-teal-700">{formatCurrency(pvpConIva)}</td>
                                
                                <td className="px-4 py-3 text-center flex justify-center gap-3">
                                    {isEditing ? (
                                        <>
                                            <button onClick={() => handleSave(item.id)} className="text-green-600 hover:text-green-900"><FaSave size={16} /></button>
                                            <button onClick={() => setEditingId(null)} className="text-gray-500 hover:text-gray-800"><FaTimes size={16} /></button>
                                        </>
                                    ) : (
                                        <>
                                            <button onClick={() => handleEditClick(item)} className="text-blue-600 hover:text-blue-900"><FaEdit size={16} /></button>
                                            <button onClick={() => eliminarProducto(item.id)} className="text-red-600 hover:text-red-900"><FaTrashAlt size={16} /></button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}